import { wceApi } from '@/api';
import type { Background, Elements, PageWidth } from './content';

export type PageItem = {
  title: string;
  url: string;
  sectionIds: string[];
  background: Background;
  pageWidth?: PageWidth;
  elements: Elements;
};

type PostDesignPagesResponse = {
  pageId: number;
};

export const createPage = (
  { title, url, ...pageInfo }: PageItem,
  cb: (pageId: number) => void
) => {
  wceApi.post<PostDesignPagesResponse>('/design/pages', {
    pageInfo: JSON.stringify(pageInfo),
    title,
    url,
  })
    .then(({ data: { pageId } }) => {
      // TODO: 응답값 pageId 확인
      cb(pageId);
    });
};

export const deletePage = (pageId: number) => {
  wceApi.delete(`/design/pages/${pageId}`);
};

export const updatePage = (
  { id, title, url, ...pageInfo }: Pick<PageItem, 'title' | 'url'> & {
    id: number;
  }
) => {
  wceApi.put(`/design/pages/${id}`, {
    title,
    url,
    pageInfo: JSON.stringify(pageInfo),
  });
};

export const updateMenus = (
  data: {
    linked: string[];
    unlinked: string[];
  }
) => {
  wceApi.put('/design/pages/menus', data);
};
